import { useT } from '@/i18n';
import { Block, Link as F7Link, Navbar, NavRight, PageContent, Preloader } from 'framework7-react';

// ─── Slide-in editor pages ───────────────────────────────────────────────────
// Each product editor is a pushed page (slides in from the right) with a Save
// link in the navbar, rather than a bottom sheet. They reuse the same *Content
// form bodies as the inline sheets and pull their data from the cached product /
// price-list queries by id, so navigating in carries no state of its own and a
// Save just navigates back.

// The Save link in the navbar fires the form body's submit. Rendered INSIDE the
// page's <Page> (route components must return <Page> as their root for F7 to
// treat them as a full stacked page - see OrderDetailPage / ProductPage).
export function EditorNavbar({
  title,
  submitRef,
  isCreate,
}: {
  title: string;
  submitRef: { current: () => void };
  // Create pages (new option / choice) show "Create"; edit pages show "Save".
  isCreate?: boolean;
}) {
  const t = useT();
  return (
    <Navbar title={title} backLink={t.back}>
      <NavRight>
        <F7Link onClick={() => submitRef.current()}>
          {isCreate ? t.createShort : t.saveShort}
        </F7Link>
      </NavRight>
    </Navbar>
  );
}

export function EditorLoadingBody() {
  return (
    <PageContent>
      <Block className="text-align-center">
        <Preloader />
      </Block>
    </PageContent>
  );
}
